<template>
  <div>
    <AdminTableContainer
      :users="localUsers"
      :headers="headers"
      :options="options"/>
    <p class="small mb-4 text-danger">By selecting "Onboard without payment" users will be uploaded into our system, but they won't have full access to SpNOD until a plan is added in the future!</p>
    <b-row class="d-flex justify-content-between px-2">
      <b-form-group>
        <b-button
          class="spnod-admin__form--button"
          type="button"
          size="sm"
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-form-group>
      <b-form-group class="d-flex justify-content-end flex-grow">
        <b-button
          class="spnod-admin__form--button"
          size="sm"
          @click="handleSave">
          <p v-if="!isSaving">Onboard without payment</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
        <b-button
          class="spnod-admin__form--button"
          size="sm"
          @click="handleSubmit">
          <p v-if="!isSubmitting">Payment</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AdminTableContainer from '../../components/AdminTableContainer'

export default {
  name: 'ReviewBulkUpload',
  components: { AdminTableContainer },
  data() {
    return {
      isSubmitting: false,
      isSaving: false,
      localUsers: {},
      headers: ['firstName', 'lastName', 'dob', 'email', 'phone'],
      options: {
        actions: ['inlineEdit', 'delete'],
        sortable: true
      }
    }
  },
  computed: {
    ...mapGetters(['users'])
  },
  methods: {
    ...mapActions(['createBulkUsers']),
    handleSave: async function() {
      this.isSaving = true
      const res = await this.createBulkUsers(this.users.data)
      this.isSaving = false
      const statusString = res.status.toString()
      if (statusString.charAt(0) === '2') {
        this.$router.push('/group/users')
      }
    },
    handleSubmit: async function() {
      this.isSubmitting = true
      const res = await this.createBulkUsers(this.users.data)
      this.isSubmitting = false
      const statusString = res.status.toString()
      if (statusString.charAt(0) === '2') {
        this.$router.push('/bulk/payment')
      }
    }
  },
  mounted() {
    this.localUsers = this.users
  },
  watch: {
    users: {
      handler: function () {
        this.localUsers = this.users
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/BulkUpload/ReviewBulkUpload.vue?3fa305b6